// ObjectPath is accessing window which breaks SSR, hence the overlay

const ObjectPath = {
	set() {},
};

export default ObjectPath;
